<template>
	<div
		:id="`text-media-${_uid}`"
		:class="[
			'c-block-list-text-media-custom',
			'w-5col >=768:w-8col max-w-full mx-auto',
		]"
	>
		<div class="overflow-auto <1024:flex <1024:flex-col-reverse">
			<div
				:class="[
					'w-4col mb-xs',
					mediaAlignment === 'left'
						? '>=1024:float-left'
						: '>=1024:float-right',
					mediaAlignment === 'left' ? '>=1024:mr-sm' : '>=1024:ml-sm',
				]"
				:style="
					image
						? `aspect-ratio: ${image.width} / ${image.height}`
						: ''
				"
			>
				<div class="relative">
					<TransitionExt
						:duration="500"
						mode="out-in"
						name="block-list-images-custom__item"
					>
						<!-- Image -->
						<UmbracoImageExt
							v-if="image"
							:id="`text-media-image-${_uid}`"
							:key="`image-${image.id}`"
							:aria-describedby="
								image.imageText ? `caption-${_uid}` : null
							"
							:widths="[320, 480, 320 * 2, 480 * 2]"
							:alt="image.altText"
							:source-url="image.cropUrl || image.url"
							:source-width="image.width"
							:source-height="image.height"
							:class="[
								'w-4col <1024:w-full',
								'rounded-md overflow-hidden',
							]"
						/>
					</TransitionExt>
					<!-- Credit -->
					<div
						v-if="image && image.imageCredits"
						:class="[
							'c-block-list-text-media-custom__credit w-fit',
							'absolute bottom-8 text-white text-16 rounded-full flex items-center justify-center py-4 px-16',
							mediaAlignment === 'left'
								? '>=1024:left-8 right-8'
								: 'right-8',
						]"
					>
						<SvgCopyright class="w-14 h-14 mr-6" />
						<div class="w-fit whitespace-nowrap">
							{{ image.imageCredits }}
						</div>
					</div>
				</div>
				<div
					v-if="image && image.imageText"
					:id="`caption-${_uid}`"
					class="s-rich-text mt-xs font-semibold text-h8 flex"
					:class="[
						mediaAlignment === 'left'
							? '>=1024:justify-start'
							: '>=1024:justify-end',
					]"
					v-html="image.imageText"
				></div>
			</div>
			<div :id="`text-media-text-${_uid}`" class="<1024:mb-sm">
				<LongReadTarget
					v-if="title"
					:container-id="`text-media-${_uid}`"
					:title="title"
				>
					<BaseH2 class="text-primary-button mb-sm" v-text="title" />
				</LongReadTarget>

				<span class="s-rich-text" v-html="text"></span>
			</div>
		</div>
	</div>
</template>

<script>
import LongReadTarget from '~/citi-baseline/components/LongReadTarget';
import UmbracoImageExt from '~/components/shared/UmbracoImageExt';
import SvgCopyright from '~/assets/svgs/copyright-icon.svg?inline';
export default {
	name: 'BlockListTextMediaCustom',
	components: { LongReadTarget, UmbracoImageExt, SvgCopyright },
	inheritAttrs: false,
	props: {
		title: String,
		image: Object,
		mediaAlignment: String,
		text: String,
	},
};
</script>
<style lang="postcss">
.c-block-list-text-media-custom__credit {
	background-color: rgba(0, 0, 0, 0.7) !important;
}
.c-block-list-text-media-custom > .s-rich-text > p {
	@apply w-4col;
}
.c-block-list-text-media-custom > .caption-w-seperator > p {
	@apply w-4col border-t-2 pt-xs border-primary-light;
}
@screen <1024 {
	.c-block-list-text-media-custom > .s-rich-text > p {
		@apply w-full;
	}
}
.c-block-list-text-media-custom ol,
.c-block-list-text-media-custom ul {
	list-style-position: outside;
}
</style>
